export const categories = [
  { slug: "dongzuo", name: "动作片", icon: "ri-sword-line" },
  { slug: "xiju", name: "喜剧片", icon: "ri-emotion-laugh-line" },
  { slug: "aiqing", name: "爱情片", icon: "ri-heart-line" },
  { slug: "kehuan", name: "科幻片", icon: "ri-rocket-line" },
  { slug: "kongbu", name: "恐怖片", icon: "ri-ghost-line" },
  { slug: "jilupian", name: "纪录片", icon: "ri-film-line" },
  { slug: "donghua", name: "动画片", icon: "ri-palette-line" },
  { slug: "juqing", name: "剧情片", icon: "ri-clapperboard-line" },
];

export const movies = [
  {
    id: 1,
    title: "星际穿越",
    slug: "interstellar",
    category: "科幻片",
    categorySlug: "kehuan",
    year: 2014,
    director: "克里斯托弗·诺兰",
    cast: ["马修·麦康纳", "安妮·海瑟薇", "杰西卡·查斯坦"],
    rating: 9.4,
    duration: "169分钟",
    description: "在不久的将来，地球上的自然资源逐渐枯竭，人类面临着生存的威胁。前NASA飞行员库珀被选中参与一项穿越虫洞的星际旅行任务，前往另一个星系寻找人类的新家园。在这场跨越时空的旅程中，库珀必须在拯救人类和守护家人之间做出艰难的选择。影片通过硬核的科学理论和感人至深的父女情感，展现了人类探索未知的勇气和对爱的执著。",
    longDescription: "《星际穿越》是一部由克里斯托弗·诺兰执导的科幻巨制，融合了黑洞理论、时间膨胀等高深的物理学概念，同时包裹着一段催人泪下的亲情故事。影片的视觉效果震撼人心，汉斯·季默的配乐更是将情感推向了极致。这部电影不仅仅是一部科幻片，更是对人类命运、爱与时间的深刻思考。",
    image: "https://readdy.ai/api/search-image?query=Interstellar%20movie%20poster%20style%20artwork%2C%20astronaut%20floating%20near%20black%20hole%2C%20cosmic%20background%20with%20stars%20and%20wormhole%2C%20cinematic%20lighting%2C%20epic%20space%20scene%2C%20dark%20and%20mysterious%20atmosphere%2C%20film%20poster%20aesthetic&width=800&height=1200&seq=movie-interstellar&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Epic%20space%20scene%20with%20giant%20wormhole%20and%20distant%20galaxy%2C%20starship%20approaching%20event%20horizon%2C%20cinematic%20wide%20shot%2C%20dark%20cosmic%20background%2C%20dramatic%20lighting%2C%20film%20banner%20style&width=1600&height=700&seq=movie-interstellar-banner&orientation=landscape",
    featured: true,
    hot: true,
    new: false,
  },
  {
    id: 2,
    title: "流浪地球2",
    slug: "wandering-earth-2",
    category: "科幻片",
    categorySlug: "kehuan",
    year: 2023,
    director: "郭帆",
    cast: ["吴京", "刘德华", "李雪健"],
    rating: 8.3,
    duration: "173分钟",
    description: "太阳即将毁灭，人类在地球表面建造出巨大的推进器，开启了长达2500年的流浪之旅。在这个过程中，人类面临了前所未有的危机和挑战。数字生命计划与移山计划的冲突，月球危机的爆发，都考验着人类的意志与智慧。",
    longDescription: "《流浪地球2》作为中国科幻电影的里程碑之作，不仅在视觉效果上达到了国际一流水平，更在故事深度上进行了大胆的探索。影片通过多条故事线的交织，探讨了在末日危机下人性的光辉与暗面。吴京和刘德华的精湛演技，加上震撼的特效场面，让这部电影成为了2023年最受瞩目的华语电影之一。",
    image: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20style%2C%20planet%20Earth%20with%20giant%20engines%20in%20space%2C%20futuristic%20technology%2C%20dramatic%20orange%20and%20blue%20lighting%2C%20epic%20cinematic%20poster%20design&width=800&height=1200&seq=movie-wandering-earth-2&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20scene%20planet%20Earth%20moving%20through%20space%20with%20giant%20thrusters%2C%20dramatic%20cosmic%20background%2C%20cinematic%20wide%20composition%2C%20orange%20sunlight%2C%20film%20banner&width=1600&height=700&seq=movie-wandering-earth-2-banner&orientation=landscape",
    featured: true,
    hot: true,
    new: false,
  },
  {
    id: 3,
    title: "孤注一掷",
    slug: "no-more-bets",
    category: "剧情片",
    categorySlug: "juqing",
    year: 2023,
    director: "申奥",
    cast: ["张艺兴", "金晨", "咏梅"],
    rating: 7.9,
    duration: "130分钟",
    description: "程序员潘生和模特梁安娜被高薪工作诱骗至境外诈骗工厂，在那里他们经历了非人的折磨。在警方跨国追查和中国驻外机构的协助下，一场惊心动魄的营救行动就此展开。",
    longDescription: "《孤注一掷》以真实的境外网络诈骗案例为原型，深刻揭露了电信诈骗的黑暗产业链。影片节奏紧凑，情节扣人心弦，张艺兴和金晨的表演令人印象深刻。这部电影不仅是一部悬疑犯罪片，更是一面照妖镜，让观众看到了贪婪和欺骗背后的残酷真相。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20style%2C%20dark%20thriller%20atmosphere%2C%20figure%20trapped%20in%20shadow%2C%20digital%20numbers%20background%2C%20intense%20and%20mysterious%20mood%2C%20red%20and%20black%20color%20scheme%2C%20film%20noir%20poster&width=800&height=1200&seq=movie-no-more-bets&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Dark%20thriller%20cinematic%20scene%2C%20mysterious%20underground%20call%20center%2C%20computer%20screens%20glowing%20in%20darkness%2C%20intense%20atmosphere%2C%20red%20ambient%20lighting%2C%20crime%20drama%20film%20banner&width=1600&height=700&seq=movie-no-more-bets-banner&orientation=landscape",
    featured: true,
    hot: true,
    new: false,
  },
  {
    id: 4,
    title: "封神第一部",
    slug: "creation-of-the-gods-1",
    category: "动作片",
    categorySlug: "dongzuo",
    year: 2023,
    director: "乌尔善",
    cast: ["费翔", "李雪健", "黄渤"],
    rating: 7.8,
    duration: "148分钟",
    description: "商王殷寿残暴无道，引发天谴。昆仑仙人姜子牙携封神榜下山，寻找天下共主以救苍生。少年姬发在经历重重磨难后，逐渐觉醒，最终踏上了反抗暴政的道路。",
    longDescription: "《封神第一部》是中国神话史诗电影的全新尝试，影片在保留传统封神故事精髓的同时，融入了现代化的叙事手法和震撼的视觉效果。费翔饰演的殷寿霸气十足，李雪健的姬昌深沉厚重，黄渤的姜子牙则带来了恰到好处的幽默感。整部电影气势恢宏，堪称国产奇幻巨制。",
    image: "https://readdy.ai/api/search-image?query=Chinese%20mythology%20epic%20movie%20poster%2C%20ancient%20warrior%20with%20armor%2C%20dragon%20and%20mythical%20creatures%2C%20golden%20and%20crimson%20color%20scheme%2C%20grand%20cinematic%20poster%20design&width=800&height=1200&seq=movie-creation-of-gods&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythological%20battle%20scene%2C%20ancient%20warriors%20and%20mythical%20beasts%2C%20dramatic%20sky%20with%20lightning%2C%20grand%20cinematic%20composition%2C%20golden%20and%20dark%20tones%2C%20film%20banner&width=1600&height=700&seq=movie-creation-of-gods-banner&orientation=landscape",
    featured: false,
    hot: true,
    new: false,
  },
  {
    id: 5,
    title: "你好，李焕英",
    slug: "hi-mom",
    category: "喜剧片",
    categorySlug: "xiju",
    year: 2021,
    director: "贾玲",
    cast: ["贾玲", "张小斐", "沈腾"],
    rating: 7.8,
    duration: "128分钟",
    description: "2001年，刚考上大学的贾晓玲遭遇了人生中的重大变故——母亲突然遭遇意外。在情绪崩溃中，她意外穿越到1981年，与年轻的母亲李焕英相遇，展开了一段笑中带泪的奇妙旅程。",
    longDescription: "《你好，李焕英》是贾玲的导演处女作，改编自她的真实经历。影片以穿越为壳，以亲情为核，前半段笑料不断，后半段催人泪下。张小斐饰演的李焕英温柔而坚韧，贾玲的表演真挚动人。这部电影不仅创造了票房奇迹，更触动了无数观众心中对母亲最柔软的情感。",
    image: "https://readdy.ai/api/search-image?query=Warm%20family%20comedy%20movie%20poster%20style%2C%20mother%20and%20daughter%20embracing%2C%20vintage%201980s%20Chinese%20setting%2C%20warm%20golden%20lighting%2C%20nostalgic%20and%20sweet%20atmosphere%2C%20emotional%20film%20poster&width=800&height=1200&seq=movie-hi-mom&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Warm%20nostalgic%20scene%201980s%20China%2C%20mother%20and%20daughter%20laughing%20together%2C%20vintage%20factory%20setting%2C%20golden%20sunlight%2C%20heartwarming%20cinematic%20composition%2C%20film%20banner&width=1600&height=700&seq=movie-hi-mom-banner&orientation=landscape",
    featured: true,
    hot: false,
    new: false,
  },
  {
    id: 6,
    title: "长津湖",
    slug: "battle-of-chosin",
    category: "动作片",
    categorySlug: "dongzuo",
    year: 2021,
    director: "陈凯歌 / 徐克 / 林超贤",
    cast: ["吴京", "易烊千玺", "段奕宏"],
    rating: 7.4,
    duration: "176分钟",
    description: "1950年，中国人民志愿军第九兵团在极寒天气下，与美军精锐部队在长津湖地区展开了一场惨烈的战役。志愿军战士们在零下四十度的严寒中，以血肉之躯筑起了保家卫国的钢铁长城。",
    longDescription: "《长津湖》以抗美援朝战争中长津湖战役为背景，全景式地展现了这场改变历史进程的重要战役。影片投资规模空前，三位顶级导演联手打造，战争场面震撼人心。影片不仅是对历史的致敬，更是对和平的珍视和对英雄的缅怀。",
    image: "https://readdy.ai/api/search-image?query=Chinese%20war%20film%20poster%20style%2C%20soldiers%20marching%20through%20snow%20covered%20mountains%2C%20extreme%20cold%20winter%20battlefield%2C%20brave%20and%20heroic%20atmosphere%2C%20dramatic%20lighting%2C%20epic%20cinematic%20poster&width=800&height=1200&seq=movie-battle-of-chosin&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Epic%20winter%20battle%20scene%20in%20snow%20covered%20mountains%2C%20soldiers%20fighting%20bravely%2C%20dramatic%20smoke%20and%20explosions%2C%20cold%20blue%20and%20white%20color%20palette%2C%20war%20film%20banner&width=1600&height=700&seq=movie-battle-of-chosin-banner&orientation=landscape",
    featured: false,
    hot: false,
    new: false,
  },
  {
    id: 7,
    title: "消失的她",
    slug: "lost-in-the-stars",
    category: "剧情片",
    categorySlug: "juqing",
    year: 2023,
    director: "崔睿 / 刘翔",
    cast: ["朱一龙", "倪妮", "文咏珊"],
    rating: 7.4,
    duration: "121分钟",
    description: "何非的妻子李木子在海外度假时神秘失踪，当他报案后，一个陌生女子突然出现，声称自己就是他的妻子。在金牌律师陈麦的介入下，更多的谜团逐渐浮出水面。",
    longDescription: "《消失的她》是一部精心设计的悬疑佳作，层层反转的剧情让人目不暇接。朱一龙饰演的何非在崩溃边缘的表演极具张力，倪妮饰演的律师陈麦冷静而犀利。影片在悬疑的外壳下，探讨了信任与欺骗、爱与执念的深刻主题。",
    image: "https://readdy.ai/api/search-image?query=Mysterious%20suspense%20thriller%20movie%20poster%20style%2C%20woman%20disappearing%20in%20tropical%20island%20setting%2C%20dark%20and%20enigmatic%20atmosphere%2C%20deep%20blue%20and%20black%20tones%2C%20cinematic%20mystery%20poster&width=800&height=1200&seq=movie-lost-in-stars&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Mysterious%20tropical%20beach%20at%20sunset%2C%20lonely%20figure%20walking%20on%20sand%2C%20dark%20ocean%20waves%2C%20suspenseful%20atmosphere%2C%20deep%20blue%20and%20purple%20tones%2C%20thriller%20film%20banner&width=1600&height=700&seq=movie-lost-in-stars-banner&orientation=landscape",
    featured: false,
    hot: true,
    new: false,
  },
  {
    id: 8,
    title: "龙猫",
    slug: "my-neighbor-totoro",
    category: "动画片",
    categorySlug: "donghua",
    year: 1988,
    director: "宫崎骏",
    cast: ["日高法子", "坂本千夏", "系井重里"],
    rating: 9.2,
    duration: "86分钟",
    description: "为了方便妻子养病，草壁达郎带着两个女儿小月和小梅搬到了乡间。在这里，小姐妹俩发现了只有纯真孩童才能看见的神奇生物——龙猫，开启了一段充满奇幻与温情的田园冒险。",
    longDescription: "《龙猫》是宫崎骏吉卜力工作室的经典之作，它没有宏大的叙事和复杂的冲突，却用最简单的故事打动了全世界观众的心。龙猫这个角色已经成为了日本动画的标志性形象，象征着童年的纯真和自然的神奇。影片的画面美轮美奂，久石让的配乐悠扬动人，是适合全家观看的暖心佳作。",
    image: "https://readdy.ai/api/search-image?query=Studio%20Ghibli%20style%20movie%20poster%2C%20cute%20big%20grey%20forest%20spirit%20creature%20with%20two%20little%20girls%2C%20magical%20forest%20setting%2C%20soft%20pastel%20colors%2C%20whimsical%20and%20warm%20atmosphere&width=800&height=1200&seq=movie-totoro&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Magical%20forest%20scene%20with%20giant%20friendly%20forest%20spirit%2C%20lush%20green%20trees%20and%20sunlight%20filtering%20through%20leaves%2C%20whimsical%20and%20peaceful%20atmosphere%2C%20Studio%20Ghibli%20aesthetic%2C%20warm%20summer%20day%2C%20film%20banner&width=1600&height=700&seq=movie-totoro-banner&orientation=landscape",
    featured: false,
    hot: false,
    new: false,
  },
  {
    id: 9,
    title: "速度与激情10",
    slug: "fast-x",
    category: "动作片",
    categorySlug: "dongzuo",
    year: 2023,
    director: "路易斯·莱特里尔",
    cast: ["范·迪塞尔", "杰森·莫玛", "米歇尔·罗德里格兹"],
    rating: 6.8,
    duration: "141分钟",
    description: "在多年的任务之后，多米尼克和他的家人们以为终于可以过上平静的生活，却遭遇了前所未有的复仇者。但丁从过去的阴影中崛起，誓要将多米尼克的一切摧毁殆尽。",
    longDescription: "作为《速度与激情》系列的第十部作品，本片延续了系列一贯的高燃动作风格，飞车追逐和爆炸场面更加疯狂。杰森·莫玛饰演的反派但丁为系列带来了全新的活力，他疯狂而不失魅力。虽然剧情逻辑经不起推敲，但作为纯粹的娱乐大片，它满足了观众对视听刺激的全部期待。",
    image: "https://readdy.ai/api/search-image?query=Fast%20and%20Furious%20style%20movie%20poster%2C%20sports%20cars%20racing%20through%20city%20streets%2C%20explosive%20action%20scene%2C%20orange%20and%20black%20color%20scheme%2C%20high%20octane%20cinematic%20poster%20design&width=800&height=1200&seq=movie-fast-x&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=High%20speed%20car%20chase%20through%20city%20streets%2C%20explosions%20and%20smoke%2C%20dramatic%20action%20scene%2C%20orange%20sunset%20lighting%2C%20cinematic%20wide%20shot%2C%20action%20film%20banner&width=1600&height=700&seq=movie-fast-x-banner&orientation=landscape",
    featured: false,
    hot: true,
    new: false,
  },
  {
    id: 10,
    title: "奥本海默",
    slug: "oppenheimer",
    category: "剧情片",
    categorySlug: "juqing",
    year: 2023,
    director: "克里斯托弗·诺兰",
    cast: ["基里安·墨菲", "艾米莉·布朗特", "马特·达蒙"],
    rating: 8.8,
    duration: "180分钟",
    description: "二战期间，美国启动了曼哈顿计划，由理论物理学家奥本海默领导研发原子弹。随着原子弹的成功爆炸和在日本的使用，奥本海默陷入了科学成就与道德困境的深渊之中。",
    longDescription: "诺兰以他一贯的非线性叙事手法，将奥本海默复杂的一生浓缩在了三个小时的电影中。基里安·墨菲的表演堪称完美，将一个天才科学家的傲慢、恐惧和悔恨展现得淋漓尽致。影片的黑白与彩色画面交替，配以令人窒息的音效设计，营造出了一种独特的沉浸式观影体验。",
    image: "https://readdy.ai/api/search-image?query=Oppenheimer%20movie%20poster%20style%2C%20man%20silhouette%20against%20mushroom%20cloud%20explosion%2C%20black%20and%20white%20with%20orange%20fire%2C%20intense%20dramatic%20atmosphere%2C%20historical%20biopic%20poster%20design&width=800&height=1200&seq=movie-oppenheimer&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Dramatic%20mushroom%20cloud%20explosion%20against%20dark%20sky%2C%20desert%20landscape%2C%20intense%20orange%20and%20black%20colors%2C%20historical%20atomic%20test%20scene%2C%20cinematic%20epic%20composition%2C%20film%20banner&width=1600&height=700&seq=movie-oppenheimer-banner&orientation=landscape",
    featured: true,
    hot: false,
    new: true,
  },
  {
    id: 11,
    title: "芭比",
    slug: "barbie",
    category: "喜剧片",
    categorySlug: "xiju",
    year: 2023,
    director: "格蕾塔·葛韦格",
    cast: ["玛格特·罗比", "瑞恩·高斯林", "亚美莉卡·费雷拉"],
    rating: 8.2,
    duration: "114分钟",
    description: "在完美的芭比乐园里，各种芭比和肯每天都过着童话般的生活。但有一天，经典芭比开始出现不完美的情况，她必须前往现实世界寻找真相，而肯也紧随其后。",
    longDescription: "《芭比》不只是一个粉红色的童话，更是一部关于自我认同和女性觉醒的聪明喜剧。玛格特·罗比完美诠释了芭比从完美到觉醒的转变，而瑞恩·高斯林饰演的肯则贡献了年度最搞笑的表演之一。影片在梦幻的外壳下探讨了深刻的性别议题，让观众在欢笑中思考。",
    image: "https://readdy.ai/api/search-image?query=Barbie%20movie%20poster%20style%2C%20woman%20in%20pink%20outfit%20in%20pastel%20dream%20world%2C%20bright%20pink%20and%20pastel%20color%20palette%2C%20playful%20and%20fashionable%20atmosphere%2C%20cinematic%20comedy%20poster&width=800&height=1200&seq=movie-barbie&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Bright%20pink%20dream%20world%20with%20palm%20trees%20and%20plastic%20toy%20houses%2C%20pastel%20color%20palette%2C%20whimsical%20and%20playful%20atmosphere%2C%20cinematic%20wide%20composition%2C%20film%20banner&width=1600&height=700&seq=movie-barbie-banner&orientation=landscape",
    featured: false,
    hot: false,
    new: true,
  },
  {
    id: 12,
    title: "长安三万里",
    slug: "chang-an",
    category: "动画片",
    categorySlug: "donghua",
    year: 2023,
    director: "谢君伟 / 邹靖",
    cast: ["杨天翔", "凌振赫", "吴俊全"],
    rating: 8.3,
    duration: "168分钟",
    description: "安史之乱后数年，吐蕃大军攻打大唐西南。困守孤城的高适向监军太监回忆起自己与李白的一生往事，两位大诗人的命运与大唐的兴衰交织在一起。",
    longDescription: "《长安三万里》是一部令人惊艳的国产动画电影，它以高适和李白跨越数十年的友情为主线，展现了大唐盛世的繁华与衰落。影片的画面极尽华美，唐诗的运用恰到好处，将中国传统文化的美展现得淋漓尽致。168分钟的片长虽长，但每一帧都值得铭记。",
    image: "https://readdy.ai/api/search-image?query=Chinese%20animation%20movie%20poster%20style%2C%20ancient%20Tang%20dynasty%20scenery%20with%20poets%20and%20warriors%2C%20traditional%20Chinese%20ink%20painting%20style%2C%20golden%20and%20crimson%20tones%2C%20poetic%20and%20grand%20atmosphere&width=800&height=1200&seq=movie-chang-an&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20city%20at%20sunset%2C%20traditional%20architecture%20and%20willow%20trees%2C%20poetic%20atmosphere%2C%20golden%20sunlight%2C%20Chinese%20painting%20aesthetic%2C%20cinematic%20film%20banner&width=1600&height=700&seq=movie-chang-an-banner&orientation=landscape",
    featured: true,
    hot: false,
    new: true,
  },
];

export const testimonials = [
  {
    id: 1,
    name: "电影爱好者小王",
    avatar: "",
    rating: 5,
    content: "青柠影院真的太好用了！片源更新快，画质清晰，而且完全免费。下班回家打开就能看，再也不用到处找资源了，强烈推荐！",
    date: "2026-07-15",
  },
  {
    id: 2,
    name: "追剧达人小李",
    avatar: "",
    rating: 5,
    content: "用了青柠影院快一年了，分类很全，科幻、动作、喜剧什么都有。最关键的是播放流畅不卡顿，wifi下看高清完全没问题。",
    date: "2026-07-10",
  },
  {
    id: 3,
    name: "影视评论人老张",
    avatar: "",
    rating: 4,
    content: "作为一个看了几十年电影的老影迷，青柠影院的片库质量让我惊喜。不仅有最新大片，还有很多经典老片和独立电影，非常难得。",
    date: "2026-06-28",
  },
  {
    id: 4,
    name: "全职妈妈周女士",
    avatar: "",
    rating: 5,
    content: "带娃之余最大的爱好就是看电影，青柠影院分类清晰，找电影特别方便。动画片专区很适合给孩子看，全家人的观影需求都满足了。",
    date: "2026-07-02",
  },
];

export const features = [
  {
    icon: "ri-movie-2-line",
    title: "海量片库",
    description: "收录数万部高清电影，涵盖动作、喜剧、科幻、爱情等多元类型，每日持续更新，追新片快人一步。",
  },
  {
    icon: "ri-4k-line",
    title: "高清画质",
    description: "支持1080P和4K超高清画质，在家也能享受影院级观影体验，每一帧都清晰细腻。",
  },
  {
    icon: "ri-wifi-line",
    title: "流畅播放",
    description: "采用先进视频加速技术，wifi环境下流畅观看不缓冲，告别卡顿烦恼。",
  },
  {
    icon: "ri-smartphone-line",
    title: "多端同步",
    description: "支持手机、平板、电脑多设备观看，观影记录云端同步，随时随地继续精彩。",
  },
];